import { useSetRecoilState } from "recoil"
import { crudSelectionProcessAtom, selectionProcessAtom } from "../atoms/selection-process.atom"
import SelectionProcessAPI from "../api/selection-process.api"

const useSelectionProcessAction = ()=>{
    const setSelectionProcessCrud = useSetRecoilState(crudSelectionProcessAtom)
    const setSelectionProcess = useSetRecoilState(selectionProcessAtom)

    const createProcessSelection = async (data, cb) =>{
        setSelectionProcessCrud((prevValues) => ({ ...prevValues, loading: true }));
        try {
          const response = await SelectionProcessAPI.createSelectionProcess(data);
          if (cb) {
            cb(response);
          }
          setSelectionProcessCrud((prevValues) => ({
            ...prevValues,
            loading: false,
            status: response.status,
          }));
        } catch (error) { 
          if(cb){
            cb(error.response?.data)
          }
            setSelectionProcessCrud((prevValues) => ({
            ...prevValues,
            loading: false,
            message: "Error al crear cargo",
            status: 500,
            error: JSON.stringify(error),
          }));
        }
      };

    const paginateSelectionProcess =  async ({ page = 1, limit = 10, search = null, clientId = '' }, cb) => {
      setSelectionProcess((prevValues) => ({ ...prevValues, loading: true }));
      try {
        let params = null;
        params = {
          paginationParams: { page, limit,},
          clientId
        };

        if (search) params.paginationParams.search = [search];
        const { data } = await SelectionProcessAPI.paginateSelectionProcess(params);
        if (cb) {
          cb(data);
        }

        setSelectionProcess((prevValues) => ({ ...prevValues, loading: false, payload: data?.data || [], total: data?.total || 0 }));

      } catch (error) {
        setSelectionProcessCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al listar perfiles profesionales",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    }

    const updateSelectionProcess = async(data,cb) =>{
      setSelectionProcessCrud((prevValues) => ({ ...prevValues, loading: true }));
      try {
        const response = await SelectionProcessAPI.updateSelectionProcess(data);
        if (cb) {
          cb(response);
        }
        setSelectionProcessCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          status: response.status,
        }));
      } catch (error) { 
        if (cb) {
          cb(error.response?.data);
        }
          setSelectionProcessCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al editar proceso",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    };

    const deleteSelectionProcess = async(id, cb)=>{
      setSelectionProcessCrud((prevValues)=>({...prevValues, loading:true}))
      try {
        const response = await SelectionProcessAPI.deleteSelectionProcess({id})
        if(cb){
          cb(response)
        }
        setSelectionProcessCrud((prevValues) => ({ ...prevValues, loading: false, status: response.status })); 
      } catch (error) {
        setSelectionProcessCrud((prevValues) => ({
          ...prevValues,
          loading: false,
          message: "Error al eliminar el proceso de selección",
          status: 500,
          error: JSON.stringify(error),
        }));
      }
    }

      return {
        createProcessSelection,
        paginateSelectionProcess,
        updateSelectionProcess,
        deleteSelectionProcess
      }
    }

    export {useSelectionProcessAction}